export const isSalesTaxCollectionEnabled =
  process.env.REACT_APP_ENABLE_SALES_TAX_COLLECTION === 'true';

type TaxDisplayInput = {
  taxAmount: number;
  taxStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
};

export const getSalesTaxDisplayValue = ({
  taxAmount,
  taxStatus,
}: TaxDisplayInput) => {
  if (taxStatus === 'loading') return 'Estimating...';

  if (taxStatus === 'succeeded' && taxAmount > 0) {
    return isSalesTaxCollectionEnabled
      ? `$${taxAmount.toFixed(2)}`
      : `Est. $${taxAmount.toFixed(2)}`;
  }

  return 'Calculated where applicable';
};

export const getCheckoutTotal = (subtotal: number, taxAmount: number) =>
  subtotal + (isSalesTaxCollectionEnabled ? taxAmount : 0);
